/**
 * @generated SignedSource<<f1f1f53e3f698bf7249fef7ff678b21b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WSTaskCollectionQuery$variables = {
  widgetId: string;
};
export type WSTaskCollectionQuery$data = {
  readonly widgetTaskCollection: {
    readonly id: string;
    readonly taskSections: ReadonlyArray<{
      readonly id: string;
      readonly section: {
        readonly id: string;
        readonly title: string | null;
      };
      readonly task: {
        readonly id: string;
        readonly routine: {
          readonly id: string;
          readonly title: string;
        };
        readonly title: string;
      };
    }>;
    readonly title: string;
  } | null;
};
export type WSTaskCollectionQuery = {
  response: WSTaskCollectionQuery$data;
  variables: WSTaskCollectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineSection",
  "kind": "LinkedField",
  "name": "section",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSTaskCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetTaskCollection",
        "kind": "LinkedField",
        "name": "widgetTaskCollection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskSections",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSTaskCollectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetTaskCollection",
        "kind": "LinkedField",
        "name": "widgetTaskCollection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskSections",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e1277a333cec037dfad87715d1a41bca",
    "id": null,
    "metadata": {},
    "name": "WSTaskCollectionQuery",
    "operationKind": "query",
    "text": "query WSTaskCollectionQuery(\n  $widgetId: ID!\n) {\n  widgetTaskCollection(id: $widgetId) {\n    id\n    title\n    taskSections {\n      __typename\n      id\n      section {\n        id\n        title\n      }\n      task {\n        __typename\n        id\n        title\n        routine {\n          id\n          title\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "224efd6e8867c4f8a95cb9c9c9115273";

export default node;
